/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorSavePersonalInfoResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'Doctor',
      },
    },
  }],
} as const;
